import React from 'react';

function NoMatch(){
   return (
        <h1>We could not find the page you are looking for</h1>
    );
}

export default NoMatch;
